<template>
    <div>
        <b-breadcrumb>
            <b-breadcrumb-item to="/">
                <i class="fa fa-home"></i>
                Home
            </b-breadcrumb-item>
            <b-breadcrumb-item to="/Facilities/Keys">Facilities</b-breadcrumb-item>
            <b-breadcrumb-item active>Locks</b-breadcrumb-item>
        </b-breadcrumb>

        <div class="card">
            <div class="card-header">
                <ul class="card-header-tabs nav nav-tabs">
                    <li class="nav-item">
                        <RouterLink :to="{name:'Keys'}" class="nav-link">
                            Keys
                        </RouterLink>
                    </li>
                    <li class="nav-item">
                        <RouterLink :to="{name:'Locks'}" class="active nav-link">
                            Locks
                        </RouterLink>
                    </li>
                </ul>
            </div>
            <div class="card-body">
                <!-- The collapsable filter options -->
                <AppFormCardCollapsable :display-footer="true" @submit.prevent="onFilterSubmit()" class="mb-3">
                    <template v-slot:header>Filter</template>
                    <template v-slot:body>
                        <div class="form-row justify-content-center">
                            <b-form-group label="Lock Type" class="col-auto" v-slot="{ lockTypeValue }">
                                <b-form-radio-group
                                      v-model="filterOptions.lockType"
                                      :options="lockTypes"
                                      :aria-describedby="lockTypeValue"
                                    ></b-form-radio-group>
                            </b-form-group>
                            <div class="col-auto form-group">
                                <label for="buildingId">Building</label>
                                <select class="form-control" v-model="filterOptions.buildingId">
                                    <option :value="null">All</option>
                                    <option :key="possibleBuilding.id" :value="possibleBuilding.id" v-for="possibleBuilding in buildings">{{possibleBuilding.name}}</option>
                                </select>
                            </div>
                            <div class="col-md-4 form-group">
                                <label>Notes/Name/Location</label>
                                <input
                                        class="form-control"
                                        placeholder="Notes/Name/Location"
                                        v-model="filterOptions.lockIdentity"
                                />
                            </div>
                        </div>
                        <div class="form-row justify-content-center">
                            <b-form-group label="Search By" class="col-auto" v-slot="{ suiteOrRoomValue }">
                                <b-form-radio-group
                                      v-model="searchForSuiteOrRoom"
                                      :options="suiteOrRoom"
                                      :aria-describedby="suiteOrRoomValue"
                                    ></b-form-radio-group>
                            </b-form-group>
                            <div v-if="searchForSuiteOrRoom === 2" class="col-auto form-group">
                                <label>Suite</label>
                                <input
                                        class="form-control"
                                        placeholder="Suite"
                                        v-model="filterOptions.suite"
                                />
                            </div>
                            <div v-if="searchForSuiteOrRoom === 1" class="col-auto form-group">
                                <label>Room</label>
                                <input
                                        class="form-control"
                                        placeholder="Room"
                                        v-model="filterOptions.room"
                                />
                            </div>
                            
                        </div>
                    </template>
                    <template v-slot:footer>
                        <button class="btn btn-primary" type="submit">Apply</button>
                    </template>
                </AppFormCardCollapsable>
                <div class="card">
                    <div class="bg-dark card-header text-white">Locks</div>
                    <div class="card-body">
                        <div class="d-print-none dropdown mb-3 text-right">
                            <button aria-expanded="false" aria-haspopup="true" class="btn btn-secondary dropdown-toggle"
                                    data-toggle="dropdown" style="width: 100px" type="button">
                                <span>Actions</span>
                            </button>
                            <div class="dropdown-menu">
                                <RouterLink :to="{name: 'AddLock'}" class="btn btn-outline-light dropdown-item text-left"
                                            title="Add New Lock">
                                    <i class="fa fa-plus"></i>Add
                                </RouterLink>
                            </div>
                        </div>
                        <BTable :busy="isLoading"
                                :fields="tableFields"
                                :items="facilitiesLocks"
                                :responsive="true"
                                primary-key="id"
                                show-empty
                                striped
                                table-class="table-align-middle">

                            <template v-slot:cell(id)="row">
                                <div class="btn-group">
                                    <router-link
                                            :to="{ name:'EditLock', params:{ id: row.item.id } }"
                                            class="btn btn-sm btn-warning d-print-none"
                                            data-toggle="tooltip"
                                            title="Edit lock details">
                                        <i class="fa fa-pencil-alt"></i>Edit
                                    </router-link>
                                    <button @click="onDeleteClick(row.item)" class="btn btn-danger btn-sm d-print-none"
                                            type="button"><i class="fa fa-trash"></i>Delete
                                    </button>
                                </div>
                            </template>

                            <template v-slot:cell(spaceType)="row">
                                <span>{{ row.item.spaceType }} {{ row.item.spaceIdentity }}</span>
                            </template>

                            <!-- Footer Pagination -->
                            <template v-slot:custom-foot>
                                <b-tr>
                                    <b-td :colspan="tableFields.length">
                                        <AppTablePagination
                                                :page.sync="filterOptions.page"
                                                :pageSize.sync="filterOptions.pageSize"
                                                :totalCount.sync="totalFacilitiesLocks"
                                                v-on:update:page="loadData()"
                                                v-on:update:pageSize="loadData()"
                                        ></AppTablePagination>
                                    </b-td>
                                </b-tr>
                            </template>
                        </BTable>
                    </div>

                  <AppModalConfirm :visible="deletingRow" @close="deletingRow=null" @confirm="onDeleteConfirmed(deletingRow)">
                      <template v-slot:header>Confirm</template>
                      <p v-if="deletingRow">Are you sure you want to delete lock{{ deletingRow.lockIdentity === null ? '' :  ' \'' + deletingRow.lockIdentity + '\'' }}
                          {{ deletingRow.buildingId !== null || deletingRow.buildingSpaceId !== null ? ' for ' + deletingRow.buildingName : '' }}
                          {{ deletingRow.buildingSpaceId !== null ? ', ' + deletingRow.spaceType + ' ' + deletingRow.spaceIdentity : '' }}?</p>
                  </AppModalConfirm>
                </div>
            </div>
    </div>
</template>

<script>
    import {ToastType} from "@/services/models/shared/ToastType";
    import AppTablePagination from "../../components/shared/AppTablePagination";
    import FacilitiesLocksService from "@/services/FacilitiesLocksService";
    import AppModalConfirm from "@/components/shared/AppModalConfirm";
    import AppFormCardCollapsable from "@/components/shared/AppFormCardCollapsable";
    import AddressService from '@/services/AddressService';

    export default {
        components: {
            AppTablePagination,
            AppModalConfirm,
            AppFormCardCollapsable
        },
        data() {
            return {
                facilitiesLocks: [],
                buildings: [],
                totalFacilitiesLocks: 0,
                deletingRow: null,
                filterOptions: {
                    page: 1,
                    pageSize: 10,
                    returnAll: false,
                    lockType: null,
                    buildingId: null,
                    suite: null,
                    room: null,
                    lockIdentity: null
                },
                isLoading: false,
                tableFields: [
                    {
                        key: 'id',
                        label: '',
                        thStyle: 'width:175px'
                    }, 
                    {
                        key: 'lockType',
                        label: 'Type'
                    },
                    {
                        key: 'buildingName',
                        label: 'Building'
                    },
                    {
                        key: 'spaceType',
                        label: 'Room/Suite',
                    },
                    {
                        key: 'lockIdentity',
                        label: 'Notes/Name/Location',
                    }
                ],
                lockTypes: [
                    {
                        value: null,
                        text: 'All'
                    },
                    {
                        value: 0,
                        text: 'Other'
                    },
                    {
                        value: 1,
                        text: 'Entrance/Door'
                    }
                ],
                searchForSuiteOrRoom: 0,
                suiteOrRoom: [
                    {
                        value: 0,
                        text: 'All'
                    },
                    {
                        value: 1,
                        text: 'Room'
                    },
                    {
                        value: 2,
                        text: 'Suite'
                    }
                ]
            }
        },
        watch: {
            searchForSuiteOrRoom (newVal) {
                this.filterOptions.room = null;
                this.filterOptions.suite = null;
            }
        },
        methods: {
            loadData() {
                const vm = this;
                vm.isLoading = true;

                FacilitiesLocksService.getFacilitiesLocks(vm.filterOptions)
                  .then(response => {
                    vm.facilitiesLocks = response.data;
                    vm.totalFacilitiesLocks = response.totalCount;
                  })
                  .catch(() => {
                    vm.redirectToError()
                  })
                  .finally(() => {
                    vm.isLoading = false;
                  })
            },
            /**
             * @description Resets the page to the first page and reloads the data
             */
            onFilterSubmit() {
                this.filterOptions.page = 1;
                this.loadData();
            },

            /**
             * @description Opens up a modal to confirm deletion of the lock
             */
            onDeleteClick(lock) {
                this.deletingRow = lock;
            },

            /**
             * @description When the user clicks 'Confirm' - the selected lock will be deleted and the modal will be closed.
             */
            onDeleteConfirmed(deletingRow) {
                const vm = this;

                FacilitiesLocksService.deleteFacilitiesLock(deletingRow.id)
                    .then(() => {
                        vm.alert(ToastType.Success, `The lock was successfully deleted`);

                        // Reload the data on the page
                        vm.loadData();
                    }).catch(error => {
                      vm.alert(ToastType.Danger, error.response.data)
                    }).finally(() => {
                      vm.deletingRow = null;
                    })
            }
        },
        created() {
            const vm = this;
            this.loadData();

            AddressService.getAllBuildings()
                .then(response => {
                    vm.buildings = response;
                })
                .catch(error => {
                    vm.buildings = [];
                })
        }
    }
</script>
